import { psCollection } from "./powersync-collection.js";
import {
  printHubSchema,
  printerSchema,
  printJobSchema,
  type PrintHub,
  type Printer,
  type PrintJob,
} from "../schemas/printing.js";

// Owner Portal's read+write surface (pairing code generation, unpair/delete)
// — same open-trust model as devicesCollection.
export const printHubsCollection = psCollection("print_hubs", printHubSchema);

// Read-only from every client — the Hub's own WS printers_sync message is
// the only legitimate writer (server-side, direct pool.query). Owner
// Portal/POS only ever read this; the collection still has write handlers so
// the collection shape matches the others, but sync-api hard-rejects any
// REST mutation attempt against this table (see routes/printing.ts).
export const printersCollection = psCollection("printers", printerSchema);

// POS's insert-only surface — `printReceipt()` (apps/pos/src/lib/print.ts)
// only ever calls `.insert({id, order_id})`; every other field is
// server-derived (see printJobsRouter's beforeInsert). PATCH is rejected
// server-side the same way printersCollection's writes are.
export const printJobsCollection = psCollection("print_jobs", printJobSchema);
